<template>
  <ul class="message-item">
    <li v-for="(item, index) in concats" class="message-list" :class="active==index?'message-active':''"
      @click="switchGroup(index, item.name)" v-if="concats.length>0">
      <div class="message-left">
        <el-badge class="item" :max="99" :value="item.unread" :hidden="item.unread===0">
          <img class="message-avatar" :src="item.avatar?item.avatar:'./static/img/Default-avatar.png'">
        </el-badge>
      </div>

      <div class="message-right">
        <div class="message-header">
          <div class="message-title">{{item.nick_name}}</div>
          <div class="message-time">{{item.last_time | formatTime}}</div>
        </div>
        <div class="message-content" v-text="item.last_msg"></div>
      </div>
    </li>
    <div class="nolist" v-if="concats.length==0">
      <div class="img">
      </div>
      <p>消息列表为空</p>
    </div>
  </ul>
</template>

<script>
  import {
    gotoBottom
  } from '@/assets/tools'

  export default {
    name: 'Message',
    props: {
      concats: {
        type: Array
      }
    },
    data() {
      return {
        gotoBottom: gotoBottom,
        active: 0
      }
    },
    watch: {
      // 被侦听的变量

    },
    created() {
      console.log(this.concats)
    },
    methods: {
      /**
       * 切换联系对象
       */
      switchGroup(index, id) {
        let concats = this.concats
        // 隐藏所有
        concats.map(item => {
          item.active = false
        })
        this.gotoBottom()
        // 显示当前点击的
        concats[index].active = true
        this.active = index;
        this.$forceUpdate()
        // 传递给父级
        this.$emit('switchGroup', index, id)
      }
    },
    /**
     * time:mins
     */
    filters: {
      formatTime(time) {
        let date = new Date(time)
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let hours = date.getHours()
        let minutes = date.getMinutes()
        var seconds = date.getSeconds()
        seconds = seconds < 10 ? `0${seconds}` : seconds
        year = `${year}`
        month = `${month}`
        day = `${day}`
        if (hours < 10) {
          hours = `0${hours}`
        }
        if (minutes < 10) {
          minutes = `0${minutes}`
        }
        return `${year}-${month}-${day}`
      }
    }
  }
</script>

<style scoped>
  .message-active {
    background: #F5F7FA;
  }

  ul {
    padding: 0;
    margin: 0;
  }

  li {
    border-bottom: 1px solid #ebeef5;
  }
.message-item {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.message-item .message-list {
  display: flex;
  padding: 10px 15px;
  width: 100%;
  height: 70px;
  font-size: 12px;
  box-sizing: border-box;
}
.nolist{
  line-height: 30px;
  text-align:center;
  color:#999;
  font-size: 20px;
}
.message-item .message-list:hover {
  background: #f2f6fc;
  cursor: pointer;
}

.message-item .message-list .message-left {
  margin-right: 10px;
  font-size: 0;
}

.message-item .message-list .message-left .message-avatar {
  width: 48px;
  height: 48px;
  border-radius: 24px;
}

.message-item .message-list .message-left .message-group {
  border: 1px solid #dedede;
  box-sizing: border-box;
}

.message-item .message-list .message-right {
  flex: 1;
  overflow: hidden;
}

.message-item .message-list .message-right .message-header {
  display: flex;
  justify-content: space-between;
  height: 22px;
  line-height: 22px;
}

.message-item .message-list .message-right .message-header .message-title {
  max-width: 160px;
  font-weight: 600;
  display: -webkit-box;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  font-size: 14px;
}

.message-item .message-list .message-right .message-header .message-time {
  color: #aaaaaa;
}

.message-item .message-list .message-right .message-content {
  margin-top: 4px;
  color: #999999;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nolist .img{
    width: 150px;
    height: 115px;
    margin: 0 auto;
   background: url(/static/img/message_empty.png);
   margin-top:120px;
}
.nolist p{
  margin-top:30px;color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/message-group.vue